import React from 'react';
import {
  missingSizeReturn,
  productSearchData,
} from '../../redux/missingSizeApiSlice';
import {CurrentProductInfo, sizeDetail} from './missingsizesconstant';

export const missingSizeFunction = (
  missingSizeApiData: missingSizeReturn,
  currentItemDetail: productSearchData,
) => {
  const sizes: string[] = [];
  const sizes2: string[] = [];
  const colorData = currentItemDetail.color.toLocaleLowerCase();
  const selectedColor = colorData.charAt(0).toUpperCase() + colorData.slice(1);
  if (missingSizeApiData.name == null) {
    return null;
  }

  const missingSizeStructure: CurrentProductInfo = {
    productPrice: missingSizeApiData.price.value,
    productName: missingSizeApiData.name,
    productCurrentColor: currentItemDetail.color,
    productCheckStatus: false,
    productSizeStatusCheck: false,
    inStockSelectedProduct: sizes,
    outOfStockSelectedProduct: sizes2,
    productByCode: new Map<string, sizeDetail[]>(),
    colorsBySize: new Map<string, string[]>(),
    sizesByColor: new Map<string, string[]>(),
  };
  const selectedItemCode = currentItemDetail.itemCode;
  missingSizeStructure.productSize = currentItemDetail.size;
  //it contain detail of the different color of the selected product
  const _colorVariants = missingSizeApiData.variants;
  if (_colorVariants == null) {
    missingSizeStructure.productSizeStatusCheck = true;
    missingSizeStructure.productByCode = Object.fromEntries(
      missingSizeStructure.productByCode,
    );
    missingSizeStructure.colorsBySize = Object.fromEntries(
      missingSizeStructure.colorsBySize,
    );
    missingSizeStructure.sizesByColor = Object.fromEntries(
      missingSizeStructure.sizesByColor,
    );
    return missingSizeStructure;
  }

  //iterating through all color variants
  for (const _colorVariant of _colorVariants) {
    //new memory allocated on every execution

    const _sizes: string[] = [];
    const _inStockSizes: string[] = [];
    const _outStockSizes: string[] = [];
    let checkOnlineItemCode = false;

    if (_colorVariant.variants == null) {
      missingSizeStructure.productSizeStatusCheck = true;
      missingSizeStructure.productByCode = Object.fromEntries(
        missingSizeStructure.productByCode,
      );
      missingSizeStructure.colorsBySize = Object.fromEntries(
        missingSizeStructure.colorsBySize,
      );
      missingSizeStructure.sizesByColor = Object.fromEntries(
        missingSizeStructure.sizesByColor,
      );
      return missingSizeStructure;
    }
    //looping size variants of a color to prep data for sizesByColor
    _colorVariant.variants.forEach(variant => {
      _sizes.push(variant.size);

      if (variant.code === selectedItemCode) {
        console.log(variant.code);
        checkOnlineItemCode = true;
      }

      //   productByCode(_colorVariant,variant);
      (missingSizeStructure.productByCode as Map<string, sizeDetail[]>).set(
        _colorVariant.color,
        _colorVariant.variants,
      );
      if (variant.stock.stockLevel > 0) {
        _inStockSizes.push(variant.size);
      }
      if (variant.stock.stockLevel == 0) {
        _outStockSizes.push(variant.size);
      }
    });
    // const onlineAvailableColor =
    //   _colorVariant.color.charAt(0).toUpperCase() +
    //   _colorVariant.color.slice(1);
    // //code need to change

    // if (onlineAvailableColor != selectedColor)
    //   missingSizeStructure.sizesByColor.set(_colorVariant.color, _inStockSizes);
    // //code need to change

    // if (onlineAvailableColor == selectedColor)
    // {
    //   missingSizeStructure.productCheckStatus = true;
    //   missingSizeStructure.productColor = {
    //     color: _colorVariant.color,
    //     sizes: _sizes,
    //   };
    //   _inStockSizes.map(size =>
    //     missingSizeStructure.inStockSelectedProduct.push(size),
    //   );
    //   _outStockSizes.map(size =>
    //     missingSizeStructure.outOfStockSelectedProduct.push(size),
    //   );
    // }
    if (checkOnlineItemCode == false) {
      console.log(checkOnlineItemCode);
      missingSizeStructure.sizesByColor.set(_colorVariant.color, _inStockSizes);
    } else {
      console.log(checkOnlineItemCode);
      missingSizeStructure.productCheckStatus = true;
      missingSizeStructure.productColor = {
        color: _colorVariant.color,
        sizes: _sizes,
      };
      _inStockSizes.map(size =>
        missingSizeStructure.inStockSelectedProduct.push(size),
      );
      _outStockSizes.map(size =>
        missingSizeStructure.outOfStockSelectedProduct.push(size),
      );
    }
  }

  (missingSizeStructure.sizesByColor as Map<string, string[]>).forEach(
    (sizes, colors) => {
      sizes.forEach(size => {
        if (missingSizeStructure.outOfStockSelectedProduct.includes(size)) {
          const _tColors = missingSizeStructure.colorsBySize.get(size) || [];
          _tColors.push(colors);
          missingSizeStructure.colorsBySize.set(size, _tColors);
        }
      });
    },
  );
  //missingSizeStructure.outOfStockSelectedProduct.push('XXL');
  (missingSizeStructure.colorsBySize as Map<string, string[]>).forEach(
    (colors, sizes) => {
      if (missingSizeStructure.outOfStockSelectedProduct.includes(sizes)) {
        const indexOf =
          missingSizeStructure.outOfStockSelectedProduct.indexOf(sizes);

        missingSizeStructure.outOfStockSelectedProduct.splice(indexOf, 1);
      }
    },
  );

  missingSizeStructure.productByCode = Object.fromEntries(
    missingSizeStructure.productByCode,
  );
  missingSizeStructure.colorsBySize = Object.fromEntries(
    missingSizeStructure.colorsBySize,
  );
  missingSizeStructure.sizesByColor = Object.fromEntries(
    missingSizeStructure.sizesByColor,
  );

  return missingSizeStructure;
};
